var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 12.54C13.5333 12.32 13.7667 12.1 13.7667 11.88C14 11.66 14 11.22 14 11C14 10.78 14 10.34 13.7667 10.12C13.5333 9.9 13.5333 9.68 13.3 9.46L3.96679 0.66C3.03347 -0.219999 1.63349 -0.219999 0.700171 0.66C-0.23315 1.54 -0.23315 2.86 0.700171 3.74L8.06674 10.6857C8.06674 9.74286 8.06656 9.68 8.06656 11C8.06656 12.32 8.06674 12.321 8.06674 11.3143L0.700171 18.26C-0.23315 19.14 -0.23315 20.46 0.700171 21.34C1.63349 22.22 3.03347 22.22 3.96679 21.34L13.3 12.54Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.2db74d1b17e50db8887e097fa960b259.svg";
export { ForwardRef as ReactComponent };